import { render, staticRenderFns } from "./NsSepaForm.vue?vue&type=template&id=27e06013&scoped=true&"
import script from "./NsSepaForm.vue?vue&type=script&lang=js&"
export * from "./NsSepaForm.vue?vue&type=script&lang=js&"
import style0 from "./NsSepaForm.vue?vue&type=style&index=0&id=27e06013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e06013",
  null
  
)

export default component.exports